export enum OnlineAccountValidation {
  NotAllRequiredParamsPasseed = 1,
  UserNotExist = 2,
  InvalidCredentials = 3,
  SomethingWrongHappened = 4,
  InvalidPassword = 5,
  EmailNotFound = 6,
  UnsupportedCustomerType=7,
  AccountLockout=8,
  UserAlreadyExist = 9,
}
